module.exports = __webpack_public_path__ + "img/procu.4224b1b6.png";